module.exports = __webpack_public_path__ + "f1f350ca0aca41bc940268e57a886360.pdf";